import React from 'react';
import { Box, styled, Text } from 'bumbag';
import format from 'date-fns/format';
import _get from 'lodash/get';

import { Link } from '@medipass/react-core/router';
import { TRANSACTION_STATUSES } from '@medipass/utils/constants';

import SecondaryStatusTag from './SecondaryStatusTag';
import TransactionStatus from './TransactionStatus';

import QuoteStatus from '../quotes/QuoteStatus';
const DateWrapper = styled(Box)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  min-width: 50px;
`;
const DetailsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 1.2rem;
`;
const Fee = styled(Box)`
  white-space: nowrap;
`;
const Month = styled(Box)`
  text-transform: uppercase;
`;
const ListItemLink = styled(Link)`
  display: block;
  text-decoration: none;

  &:nth-child(odd) {
    background-color: #f2f4f8;
  }
  &:hover {
    background-color: #dedede;
  }
`;
const ListItem = styled(Box)`
  background-color: inherit;
  padding: 1rem;
  min-height: 100px;
`;
const SpaceBetween = styled(Box)`
  display: flex;
  justify-content: space-between;
`;
type Props = {
  amountString: string;
  dateString: string;
  isQuote?: boolean;
  item: Record<string, any>;
  linkTo: string;
  secondaryStatus?: string | null | undefined;
  status?: string | null | undefined;
};
export default class TransactionsListItem extends React.Component<Props> {
  static defaultProps = {
    isQuote: false,
    secondaryStatus: undefined,
    status: undefined,
  };
  render = () => {
    const { amountString, dateString, isQuote, item, linkTo, secondaryStatus, status } = this.props;
    return (
      <ListItemLink
        to={linkTo}
        style={{
          color: 'inherit',
        }}
      >
        <ListItem>
          <SpaceBetween>
            <Box display="flex">
              <DateWrapper>
                <Month className="title is-6 margin-bottom-0">{format(dateString, 'MMM')}</Month>
                <Box className="title is-4">{format(dateString, 'DD')}</Box>
              </DateWrapper>
              <DetailsWrapper>
                <Box>
                  {/* @ts-expect-error TS(2322): Type '"0"' is not assignable to type 'Flexible<Spa... Remove this comment to see the full error message */}
                  <Box className="title is-6" marginBottom="0">
                    {isQuote && status === TRANSACTION_STATUSES.REQUESTED
                      ? 'Waiting for reply'
                      : `${_get(item, 'staff.firstName')} ${_get(item, 'staff.lastName')}`}
                  </Box>
                  {/* @ts-expect-error TS(2322): Type '"0"' is not assignable to type 'Flexible<Spa... Remove this comment to see the full error message */}
                  <Box marginBottom="0">
                    <Text fontSize="150">{_get(item, 'practice.displayName')}</Text>
                  </Box>
                  <Box marginBottom="major-1">
                    <Text fontSize="150">{_get(item, 'practice.city')}</Text>
                  </Box>
                </Box>
                {!isQuote && (
                  <Box>
                    <Text fontSize="150" fontWeight="semibold">
                      {_get(item, 'modality.displayName')}{' '}
                      {_get(item, 'patient.firstName') && ` for ${item.patient.firstName}`}
                    </Text>
                  </Box>
                )}
              </DetailsWrapper>
            </Box>
            <SpaceBetween
              className="has-text-right"
              style={{
                flexDirection: 'column',
              }}
            >
              <Fee className="title is-4 has-text-weight-bold">{amountString}</Fee>
              {secondaryStatus && <SecondaryStatusTag status={secondaryStatus} />}
              {status && <Box>{isQuote ? <QuoteStatus status={status} /> : <TransactionStatus status={status} />}</Box>}
            </SpaceBetween>
          </SpaceBetween>
        </ListItem>
      </ListItemLink>
    );
  };
}
